<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="false"
    :max-width="1000"
  >
    <template slot="header">
      <span v-if="item">Job: {{ item.wo_number }} - {{ item.project }}; {{ item.project_floor }}</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col>
          <v-card
            elevation="0"
            outlined
          >
            <v-data-table
              :headers="headers"
              :items="items"
              hide-default-footer
              :items-per-page="-1"
              :loading="loading"
              dense
            >
              <template #[`item.status`]="{ item }">
                <v-chip
                  v-if="item && item.status"
                  small
                  :color="getStatusColor(item.status.id)"
                  text-color="white"
                >
                  {{ item.status.name }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-end">
          <span style="font-size: 20px; font-weight: bold; color: #000000;">Total Items: {{ items.length }}</span>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    items: [],
    headers: [
      { text: 'Serial#', value: 'index' },
      { text: 'Tag Id', value: 'tag_id' },
      { text: 'Tag Number', value: 'tag_number' },
      { text: 'Work Order', value: 'work_order' },
      { text: 'Reference', value: 'floor_number' },
      { text: 'Cut Width', value: 'cut_width' },
      { text: 'Status', value: 'status', align: 'center' },
    ],
    loading: false,
    item: null,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
  },
  methods: {

    async get(item, statusId) {
      this.loading = true;
      this.items = [];
      const submitModel = {
        filters: {
          production_schedule_id: item.id,
          status_id: statusId,
        },
      };
      const res = await this.$api.finishedGood.read(submitModel);
      this.loading = false;
      if (!res) return;
      this.items = res;
    },

    open(item, statusId) {
      this.item = item;
      this.get(item, statusId);
      this.$refs.dialogBox.open();
    },

    getStatusColor(statusId) {
      if (statusId === 2) return '#F7A51C';
      if (statusId === 3) return '#1870CB';
      if (statusId === 4) return '#00BFA5';
      if (statusId === 5) return '#9C27B0';
      if (statusId === 6) return '#F7E800';
      return '#000000';
    },
  },
};
</script>
